import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PencilSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 20 20' fill='none'>
    <path
      d='M14.1667 2.50025C14.3856 2.28138 14.6455 2.10776 14.9314 1.98931C15.2174 1.87086 15.5239 1.80989 15.8334 1.80989C16.1429 1.80989 16.4494 1.87086 16.7354 1.98931C17.0214 2.10776 17.2812 2.28138 17.5001 2.50025C17.719 2.71912 17.8926 2.97895 18.011 3.26492C18.1295 3.55089 18.1904 3.85738 18.1904 4.16691C18.1904 4.47644 18.1295 4.78294 18.011 5.06891C17.8926 5.35487 17.719 5.61471 17.5001 5.83358L6.25008 17.0836L1.66675 18.3336L2.91675 13.7502L14.1667 2.50025Z'
      stroke='currentcolor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const PencilIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PencilSvg} {...props} />
);
